export default function getCodeTree(language, code, astGenerator) {
  if (language === 'text' || !astGenerator) {
    return [{
      type: 'text',
      value: code
    }];
  }
  try {
    return astGenerator.highlight(code, language);
  } catch (e) {
    return [{
      type: 'text',
      value: code
    }];
  }
}